<template>
  <div class="Div">
    <div class="backimg">

      <img
        class="img"
        :src="banner.banner_img"
        alt=""
      >
      <div class="Title">
        {{banner.banner_name_cn}}
        <p>{{banner.banner_name_en}}</p>
      </div>
    </div>
    <div class="nav">
      <ul>
        <li
          :class="navId==i?'li active':'li'"
          v-for="(item,i) of warmNav"
          :key="i"
          @click="navClick(i)"
        >
          {{item.type_name_cn}}
        </li>
      </ul>
    </div>
    <idea-com v-if="navId==0"></idea-com>
    <Features v-else-if="navId==1"></Features>
    <SchoolLife v-else-if="navId==2"></SchoolLife>
    <SchoolServing v-else-if="navId==3"></SchoolServing>
    <Advantage v-else-if="navId==4"></Advantage>
  </div>
</template>
<script>
import ideaCom from "../../components/SchoolStrategy/Idea"; //办学理念
import Features from "../../components/SchoolStrategy/Features"; //办学特色
import SchoolLife from "../../components/SchoolStrategy/SchoolLife"; //校园生活
import SchoolServing from "../../components/SchoolStrategy/SchoolServing"; //温馨服务
import Advantage from "../../components/SchoolStrategy/Advantage"; //办学优势
import {getBanner,Strategy_type} from '../../api/home'
// Advantage
export default {
  name: "SchoolStrategy",
  data() {
    return {
      warmNav: [
        {
          name: "领先的办学理念",
          id: 0
        },
        {
          name: "独有的办学特色",
          id: 1
        },
        {
          name: "精彩的校园生活",
          id: 2
        },
        {
          name: "温馨的校园服务",
          id: 3
        },
        {
          name: "强大的办学优势",
          id: 4
        }
      ],
      navId: 0,
      banner:{}
    };
  },
  components: {
    ideaCom,
    Features,
    SchoolLife,
    SchoolServing,
    Advantage
  },
  methods: {
    navClick(item) {
      this.navId = item;
      // this.page = 1;
      //   console.log(this.page);
    },
    changePage(val) {
      this.page = val;
    }
  },
  created(){
    getBanner({
      address:21
    }).then(res=>{
      // console.log(res.data)
      this.banner=res.data
    });
    // 导航栏
    Strategy_type({}).then(res=>{
      // console.log(res.data)
      this.warmNav=res.data
    })

  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  // min-height: 100%;
  //   padding: 0.1px 0;
  //   background: #f5f5f5;
  .backimg {
    position: relative;
    width: 100%;
    height: px2Rem(400px);
    &::after {
      display: block;
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      //   z-index: 1;
    }
    .img {
      //   position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.Title {
  position: absolute;
  width: 100%;
  top: px2Rem(130px);
  font-size: px2Rem(80px);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  z-index: 1;
  text-shadow: 5px 3px 0px rgba(4, 13, 40, 0.64);
  p {
    margin-top: px2Rem(40px);
    font-size: px2Rem(40px);
  }
}
.nav {
  width: 100%;
  height: px2Rem(100px);
  background: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 9px 0px rgba(0, 0, 0, 0.3);
  line-height: px2Rem(100px);
  ul {
    width: px2Rem(1300px);
    height: 100%;
    margin: auto;
    // overflow-x: scroll;
    // overflow-y: hidden;
    // word-break:keep-all;
    // white-space:nowrap;     
    .li {
      display: inline-block;
      position: relative;
      height: 100%;
      margin-right: px2Rem(40px);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(120, 120, 120, 1);
      cursor: pointer;
      //   transition: 0.3s;
      &:last-of-type {
        margin-right: 0;
      }
      &::after {
        display: block;
        position: absolute;
        width: px2Rem(0px);
        height: 2px;
        content: "";
        transition: 0.3s;
        left: 50%;
        // bottom: 0;
        transform: translate(-50%, 0);
      }
      &:hover {
        &::after {
          display: block;
          content: "";
          position: absolute;
          width: px2Rem(110px);
          height: 2px;
          bottom: 0;
          background: rgba(28, 50, 120, 1);
          border-radius: 1px;
          transition: 0.3s;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }
    }
    .active {
      font-size: px2Rem(34px);
      color: #333;
      &::after {
        display: block;
        content: "";
        position: absolute;
        width: px2Rem(110px);
        height: 2px;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        background: rgba(28, 50, 120, 1);
        border-radius: 1px;
      }
    }
  }
}

.page {
  margin-top: px2Rem(40px);
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/index/SchoolStrategy.vue